import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const Team = styled.div`
  display: flex;
  line-height: 1;
  align-items: center;
  padding-bottom: 8px;

  &:first-child:last-child {
    padding-bottom: 0;
  }
`;

export const Title = styled.div<{
  bolt?: boolean;
  selectedGames?: boolean;
  whiteText?: boolean;
  $justify?: boolean;
}>`
  color: var(--v3-${props => (props.whiteText ? 'white' : 'text-color')});
  ${props => props.bolt && 'font-weight: 600;'}
  ${props => props.$justify && 'justify-content: space-between;'}
  ${props =>
    props.selectedGames
      ? `
      justify-content: flex-end;
    `
      : `
      flex: 1;
    `}
  
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
`;

export const Header = styled.div<{
  selectedGames?: boolean;
  calendar?: boolean;
  whiteText?: boolean;
}>`
  ${props =>
    props.selectedGames
      ? `
      padding: 0;
      margin: 0 12px;
      height: 44px;`
      : ` 
      padding: 0 8px;
      margin: 0;
      height: ${props.calendar ? '36' : '32'}px;
    `}

  display: flex;
  align-items: center;
  border-bottom: 1px solid
    ${props =>
      props.whiteText ? 'var(--v3-black-15-fixed)' : 'var(--v3-black-4)'};

  .calendar-left {
    display: flex;
    align-items: center;

    &-icon {
      margin-right: 7px;
    }
  }

  .calendar-right {
    display: flex;
    gap: 8px;
    align-items: center;
    color: var(--v3-black-45);
    margin-left: 8px;

    &-time {
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.1px;
      color: var(--v3-text-color);
    }
  }
`;

export const Wrapper = styled.div<{
  selectedGames?: boolean;
  calendar?: boolean;
  isBoostedOdd?: boolean;
}>`
  margin-bottom: ${props =>
    props.calendar ? '4' : props.isBoostedOdd ? '0' : '2'}px;

  ${props =>
    props.selectedGames
      ? `padding: 8px 12px 12px 12px;
    `
      : ` padding: 8px;
    `}
`;

export const Container = styled.div<{
  active: boolean;
  selectedGames?: boolean;
  bgImg?: string;
  calendar?: boolean;
  isLive?: boolean;
}>`
  position: relative;
  ${props =>
    props.calendar
      ? `border-radius: 6px;
    box-shadow: var(--v3-shadow-strong);
  `
      : ''}
  cursor: pointer;
  background-color: var(--v3-black-0);
  ${props =>
    props.selectedGames && props.bgImg
      ? `background-image: url(${props.bgImg});
     background-position: center;
     background-repeat: no-repeat;
     background-size: cover;
  `
      : ''}
  &:last-child {
    ${Wrapper} {
      margin-bottom: unset;
    }
  }
  ${props =>
    !isMobile() &&
    `    
    ${
      props.active
        ? `
        border-left: 4px solid var(--v3-primary-6);        
      `
        : ''
    }
  `}
`;

export const Action = styled.div`
  color: var(--v3-primary-4);
  margin-left: 4px;
  font-size: 16px;
  display: flex;
  align-items: center;
`;
